import { render, staticRenderFns } from "./order-appart-add-or-update.vue?vue&type=template&id=c142baaa&scoped=true"
import script from "./order-appart-add-or-update.vue?vue&type=script&lang=js"
export * from "./order-appart-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./order-appart-add-or-update.vue?vue&type=style&index=0&id=c142baaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c142baaa",
  null
  
)

export default component.exports